export const normalizePhoneNumber = (phoneNumber?: string) => {
  return (phoneNumber ?? "")
    .replaceAll(" ", "")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll("-", "")
    .replace(/^\+1/, ""); // Remove +1 country code
};
